import { Button, Typography } from "@mui/material";
import React from "react";

interface OrderStatusButtonProps {
  label: string;
  group: string | number; // adjust to your enum type
  activeGroup: string | number;
  onChange: (group: any) => void;
  statusCountData?: Record<string, number>;
  filters: { advancedSearchExpanded: boolean };
  statusesCountLoading: boolean;
}

const OrderStatusButton: React.FC<OrderStatusButtonProps> = ({
  label,
  group,
  activeGroup,
  onChange,
  statusCountData,
  filters,
  statusesCountLoading,
}) => {
  return (
    <Button
      className="historyTabButton"
      onClick={() => onChange(group)}
      disabled={statusesCountLoading}
      sx={{
        textTransform: "capitalize",
        cursor: "pointer",
        borderRadius: 0,
        fontWeight: group === activeGroup ? "bold" : 500,
        color: group === activeGroup ? "#62B5E5" : "text.secondary",
        borderBottom:
          group === activeGroup ? "2px solid #62B5E5" : "2px solid transparent",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "transparent",
          color: group === activeGroup ? "#62B5E5" : "text.primary",
          borderBottom:
            group === activeGroup
              ? "2px solid #62B5E5"
              : "2px solid rgba(0,0,0,0.2)",
        },
      }}
    >
      {label}

      <Typography
        sx={{
          marginLeft: 2,
          padding: "2px 6px",
          borderRadius: "6px",
          fontSize: "0.85rem",
          fontWeight: 500,
          backgroundColor: group === activeGroup ? "#62B5E540" : "#E0E0E0",
          color: group === activeGroup ? "#62B5E5" : "text.primary",
        }}
      >
        {statusCountData && statusCountData[group]}
      </Typography>
    </Button>
  );
};

export default OrderStatusButton;
